class FinalSaleTooltip extends HTMLElement {
  static nextId = 0;

  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.button = this.querySelector('button');
    this.tooltip = this.querySelector('[role="tooltip"]');
    if (!this.button || !this.tooltip) return;

    if (!this.tooltip.id || document.getElementById(this.tooltip.id) !== this.tooltip) {
      do {
        this.tooltip.id = `FinalSaleTooltip-${++FinalSaleTooltip.nextId}`;
      } while (document.getElementById(this.tooltip.id) !== this.tooltip);
    }
    this.button.setAttribute('aria-describedby', this.tooltip.id);
    this.close();
    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') this.show();
    }, { signal });
    this.addEventListener('pointerleave', () => {
      if (!this.pinned && !this.contains(document.activeElement)) this.close();
    }, { signal });
    this.addEventListener('focusin', () => this.show(), { signal });
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.close();
    }, { signal });
    this.button.addEventListener('click', () => {
      if (this.pinned) this.close();
      else {
        this.pinned = true;
        this.show();
      }
    }, { signal });
    document.addEventListener('pointerdown', (event) => {
      if (!this.contains(event.target)) this.close();
    }, { signal });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && !this.tooltip.hidden) {
        event.stopPropagation();
        this.close();
      }
    }, { signal, capture: true });
    window.addEventListener('resize', () => {
      if (!this.tooltip.hidden) this.position();
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  show() {
    this.tooltip.hidden = false;
    this.setAttribute('open', '');
    this.button.setAttribute('aria-expanded', 'true');
    this.position();
  }

  close() {
    this.pinned = false;
    this.tooltip.hidden = true;
    this.removeAttribute('open');
    this.button.setAttribute('aria-expanded', 'false');
  }

  position() {
    let left = 16;
    let right = document.documentElement.clientWidth - 16;
    for (let ancestor = this.parentElement; ancestor; ancestor = ancestor.parentElement) {
      if (!/hidden|clip|auto|scroll/.test(getComputedStyle(ancestor).overflowX)) continue;
      const rect = ancestor.getBoundingClientRect();
      left = Math.max(left, rect.left + ancestor.clientLeft + 8);
      right = Math.min(right, rect.left + ancestor.clientLeft + ancestor.clientWidth - 8);
    }
    this.tooltip.style.setProperty('--final-sale-tooltip-max-width', `${Math.max(0, right - left)}px`);
    this.tooltip.style.setProperty('--final-sale-tooltip-shift', '0px');
    const rect = this.tooltip.getBoundingClientRect();
    const shift = Math.max(left - rect.left, Math.min(0, right - rect.right));
    this.tooltip.style.setProperty('--final-sale-tooltip-shift', `${Math.round(shift)}px`);
  }
}

customElements.define('final-sale-tooltip', FinalSaleTooltip);
